import React, { Component } from 'react';
import debounce from 'lodash/debounce';

import Button from '../button/button';
import { ref } from '../../helpers';

import './_query-status.scss';

export default class QueryStatus extends Component {
    constructor () {
        super();

        this.state = {
            overflowing: false,
            open: false
        };

        this.lastWindowWidth = null;

        this.debouncedHandleWindowResize = debounce(this.handleWindowResize, 200);
    }

    componentDidMount () {
        window.addEventListener('resize', this.debouncedHandleWindowResize);

        if (this.props.collapsible) {
            this.measureOverflow();
        }
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.debouncedHandleWindowResize);
    }

    componentDidUpdate (prevProps) {
        if (this.props.collapsible && this.props.query !== prevProps.query) {
            this.measureOverflow();
        }
    }

    render (props, state) {
        let units = (props.query.units === 'value') ? 'value (US $)' : 'weight';

        let classname = 'querystatus';
        if (props.kind) {
            classname += ` querystatus--${props.kind}`;
        }

        if (state.overflowing) {
            classname += ' is-overflowing';
        }

        if (state.open) {
            classname += ' is-open';
        }

        return (
            <div class={ classname }>
                <div class="querystatus__bg" />
                <h1>You are viewing</h1>
                <p>
                    <span ref={ ref(this, 'refText') }>
                        {/* Wrap plain text in spans to prevent whitespace being removed */}
                        <em>{ props.query.exporter.model.name } </em>
                        <span>exporting </span>
                        <em>{ props.query.category.model.name } </em>
                        <span>to </span>
                        <em>{ props.query.importer.model.name }</em>
                        <span>, </span>
                        <span> in </span>
                        <em>{ props.query.year.id } </em>
                        <span>by </span>
                        <em>{ units }</em>
                    </span>
                </p>
                {
                    props.collapsible ?
                    <Button
                        icon={ state.open ? 'up' : 'down' }
                        kind="icon-box"
                        handleClick={ this.handleClickToggle }
                    /> :
                    null
                }
            </div>
        );
    }

    handleWindowResize = () => {
        let windowWidth = document.body.clientWidth;

        if (this.lastWindowWidth && this.lastWindowWidth === windowWidth) {
            return;
        }

        if (this.state.open) {
            return;
        }

        this.measureOverflow();

        this.lastWindowWidth = windowWidth;
    }

    handleClickToggle = () => {
        this.setState({
            open: !this.state.open
        });
    }

    measureOverflow () {
        if (!this.refText) {
            return;
        }

        const textWidth = this.refText.offsetWidth;
        const containerWidth = this.refText.parentNode.offsetWidth;

        this.setState({
            overflowing: (textWidth > containerWidth)
        });
    }
}
